<div>
  <!-- Button Group -->
  <div class="trial-insights-table-button-container" *ngIf="options.buttons.display">
    <button
      class="trial-insights-table-button"
      *ngFor="let button of options.buttons.data"
      [ngClass]="{ active: button.key === selectedKey }"
      (click)="select(button.key)">
        {{ button.value }}
    </button>
  </div>

  <!-- Table Header -->
  <div class="trial-insights-table-header-container" *ngIf="options.header.display">
    <span class="trial-insights-table-header flex-grow">{{ headers[0] }}</span>
    <div class="sort" (click)="sort()">
      <span class="trial-insights-table-header select-none">{{ headers[1] }}</span>

      <!-- Toggle sort direction -->
      <div class="flex ml-1" *ngIf="!isLoadingRemaining">
        <span class="trial-insights-table-header sorting-icon" *ngIf="sortOrder === 'DESC'">&darr;</span>
        <span class="trial-insights-table-header sorting-icon" *ngIf="sortOrder === 'ASC'">&uarr;</span>
      </div>

      <!-- Toggle spinner -->
      <div class="trial-insights-table-spinner-container" *ngIf="isLoadingRemaining">
        <div class="dot-flashing"></div>
      </div>
    </div>
  </div>

  <!-- Table -->
  <div class="trial-insights-table-row-container">
    <!-- Table Row -->
    <div class="trial-insights-table-row" *ngFor="let row of rowData" [class.compact]="options.rowData.compact">
      <!-- Color Icon -->
      <div
        class="trial-insights-table-row-icon"
        *ngIf="row.color"
        [style.background-color]="row.color ? row.color : ''">
      </div>

      <!-- Left side -->
      <div class="trial-insights-table-row-text left">
        <span class="header">{{ row.leftHeader }}</span>
        <span class="subheader">{{ row.leftSubheader }}</span>
      </div>

      <!-- Right Side -->
      <div class="trial-insights-table-row-text right">
        <span class="header">{{ row.rightHeader }}</span>
        <span class="subheader">{{ row.rightSubheader }}</span>
      </div>
    </div>
  </div>

  <!-- Link -->
  <div class="trial-insights-table-link-container" *ngIf="options.link.display">
    <a [routerLink]="options.link.url">{{ options.link.value }}</a>
  </div>
</div>
